<template>
  <v-row>
    <slot name="title" />
    <v-col
      v-for="t in templates"
      :key="t.id"
      :cols="cardCols"
      :sm="cardColsSm"
      :md="cardColsMd"
      :lg="cardColsLg"
    >
      <v-card
        outlined
        @click="selectTemplate(t)"
      >
        <html-image
          style="aspect-ratio : 1 / 1; overflow: hidden;"
          fill-height
          :html="t.preview"
        />

        <v-card-title class="pa-1">
          <v-spacer />
          <span class="text-body-2 ellipsize">{{ t.name }}</span>
          <v-spacer />
          <v-menu
            v-if="allowActions"
            bottom
            left
          >
            <template #activator="{ on, attrs }">
              <v-btn
                x-small
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list class="py-0 my-0">
              <!-- duplicate -->
              <v-list-item @click="duplicateTemplate(t)">
                <v-list-item-title>{{ $t('button.duplicate') }}</v-list-item-title>
                <v-list-item-icon>
                  <v-icon small>
                    mdi-content-duplicate
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>

              <div v-if="!t.isDefault">
                <!-- edit -->
                <v-list-item @click="editTemplate(t)">
                  <v-list-item-title>{{ $t('button.edit') }}</v-list-item-title>
                  <v-list-item-icon>
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <!-- rename -->
                <v-list-item @click="renameTemplate(t)">
                  <v-list-item-title>{{ $t('button.rename') }}</v-list-item-title>
                  <v-list-item-icon>
                    <v-icon small>
                      mdi-rename
                    </v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <!-- delete -->
                <v-divider />
                <v-list-item @click="deleteTemplate(t)">
                  <v-list-item-title class="red--text">
                    {{ $t('button.delete') }}
                  </v-list-item-title>
                  <v-list-item-icon>
                    <v-icon
                      small
                      color="red"
                    >
                      mdi-delete
                    </v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import HtmlTemplate from '@/grpc-api/model/html-template';
import { PropType } from 'vue';
import HtmlImage from '@/components/util/HtmlImage.vue';

const props = defineProps({
  templates: { type: Array as PropType<Array<HtmlTemplate>>, required: true },
  cardCols: { type: Number, required: false, default: 6 },
  cardColsSm: { type: Number, required: false, default: 4 },
  cardColsMd: { type: Number, required: false, default: 3 },
  cardColsLg: { type: Number, required: false, default: 2 },
  allowActions: { type: Boolean, required: false, default: false },
});

// eslint-disable-next-line vue/max-len
const emit = defineEmits<{(e: 'select-template'|'edit-template'|'duplicate-template'|'delete-template'|'rename-template', templte: HtmlTemplate): void}>();

const selectTemplate = (t: HtmlTemplate) => {
  emit('select-template', t);
};

const editTemplate = (t: HtmlTemplate) => {
  emit('edit-template', t);
};

const duplicateTemplate = (t: HtmlTemplate) => {
  emit('duplicate-template', t);
};

const deleteTemplate = (t: HtmlTemplate) => {
  emit('delete-template', t);
};

const renameTemplate = (t: HtmlTemplate) => {
  emit('rename-template', t);
};

</script>

<style>

</style>
